import { format, startOfToday } from 'date-fns'
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useImmerReducer } from 'use-immer'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import DisponibilidadeSemanal from './components/DisponibilidadeSemanal'

const STATUS_AGENDAMENTO = {
  PREPARACAO: 'Preparação',
  CONFIRMADO: 'Confirmado',
  PRESENTE: 'Presente',
  FALTA: 'Falta',
  DESMARCADO: 'Desmarcado',
}

const initialValues = {
  statics: {
    agendamentos: 0,
    preparacao: 0,
    confirmados: 0,
    presenca: 0,
    falta: 0,
    desmarcados: 0,
  },
}

const reducer = (state = initialValues, { type, field, value }) => {
  switch (type) {
    case 'setStatics':
      state.statics = value
      break
    default:
      state[field] = value
  }
}

export const AgendaContext = createContext(initialValues)

const AberturaAutoagendamento = () => {
  const { agenda } = useContext(GlobalContext)
  const [ferramentas, setFerramentas] = useState()
  const [agendaSelecionada, setAgendaSelecionada] = useState(agenda)

  const [state, dispatch] = useImmerReducer(reducer, initialValues)

  const contextValues = useMemo(
    () => ({ ...state, dispatch }),
    [state, dispatch],
  )

  const returnStatics = useCallback((lista) => {
    const contadores = {
      [STATUS_AGENDAMENTO.PREPARACAO]: 0,
      [STATUS_AGENDAMENTO.CONFIRMADO]: 0,
      [STATUS_AGENDAMENTO.PRESENTE]: 0,
      [STATUS_AGENDAMENTO.FALTA]: 0,
      [STATUS_AGENDAMENTO.DESMARCADO]: 0,
    }

    lista.forEach((item) => {
      const status = item[5]
      if (status in contadores) {
        contadores[status]++
      }
    })

    return {
      agendamentos: lista.length,
      preparacao: contadores[STATUS_AGENDAMENTO.PREPARACAO],
      confirmados: contadores[STATUS_AGENDAMENTO.CONFIRMADO],
      presenca: contadores[STATUS_AGENDAMENTO.PRESENTE],
      falta: contadores[STATUS_AGENDAMENTO.FALTA],
      desmarcados: contadores[STATUS_AGENDAMENTO.DESMARCADO],
    }
  }, [])

  const listaAgendamentos = useCallback(() => {
    setFerramentas(<></>)
    metodoPrograma(
      'lista',
      {
        idAgenda: agendaSelecionada?.[0]?.[0],
        data: format(startOfToday(), 'yyyy-MM-dd'),
      },
      'CtrlAberturaAutoagendamento',
    ).then((res) => {
      if (res.status) {
        dispatch({ type: 'setStatics', value: returnStatics(res.lista) })
      }
    })
  }, [agendaSelecionada, dispatch, returnStatics])

  useEffect(() => {
    if (agendaSelecionada) {
      listaAgendamentos()
    }
  }, [listaAgendamentos, agendaSelecionada])

  return (
    <AgendaContext.Provider value={contextValues}>
      <Programa
        codigo={'CtrlAberturaAutoagendamento'}
        ferramentas={ferramentas}
      >
        <DisponibilidadeSemanal
          idAgenda={agendaSelecionada?.[0]?.[0]}
          onSaved={listaAgendamentos}
          agendaSelecionada={agendaSelecionada}
          onAgendaChange={(_, val) => setAgendaSelecionada(val)}
        />
      </Programa>
    </AgendaContext.Provider>
  )
}

export default AberturaAutoagendamento
